import { Routes } from '@angular/router';
import { DashboardPageComponent } from './pages/dashboard/dashboard.component';
import { PermissionsList } from '../../shared/common/PermissionList';

export const DashboardRoutes: Routes = [
  {
    path: 'home',
    component: DashboardPageComponent,
    title: 'Safety | ADROIT',
    data: {
      animation: 'home',
      PermissionPageName: [
        PermissionsList[PermissionsList.OverviewView],
        PermissionsList[PermissionsList.TrackingView],
        PermissionsList[PermissionsList.TelematicsView],
      ],
    },
  },
];
